import { useEffect, useState } from 'react';
import { Globe } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import useJeMobil from '../hooks/useJeMobil';
import TabBar from '../components/layout/TabBar';
import WebAkce from '../components/web/WebAkce';

const BARVA = '#10B981';

/**
 * Modul Web (sekce Obchod, 2026-10-28) — co se ukazuje na fofrlama.cz.
 * Záložky (klíče `web.*`):
 *  - akce → kalendář akcí: úvod webu ukazuje nejbližší tři, stránka Akce všechny
 */
export default function Web({ user, initialTab = null }) {
    const { theme } = useTheme();
    const isDark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    const isMobile = useJeMobil();
    const [tab, setTab] = useState(initialTab || 'akce');
    useEffect(() => { if (initialTab) setTab(initialTab); }, [initialTab]);

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ flexShrink: 0 }}>
                {!isMobile && (
                    <div className="flex items-center gap-3 mb-4">
                        <div className="flex items-center justify-center shrink-0" style={{ width: 40, height: 40, borderRadius: 7, border: `1px solid ${BARVA}40` }}>
                            <Globe size={20} style={{ color: BARVA }} />
                        </div>
                        <div className="min-w-0">
                            <h1 className="text-lg font-bold" style={{ color: 'var(--text-primary)' }}>Web</h1>
                            <p className="text-xs" style={{ color: 'var(--text-secondary)' }}>Co se ukazuje na fofrlama.cz</p>
                        </div>
                    </div>
                )}
                <TabBar modul="web" user={user} aktivni={tab} onZmena={setTab} barva={BARVA} isDark={isDark} isMobile={isMobile} />
            </div>
            <div style={{ flex: 1, minHeight: 0, paddingTop: 16, overflowY: 'auto' }}>
                {tab === 'akce' && <WebAkce user={user} isDark={isDark} isMobile={isMobile} barva={BARVA} />}
            </div>
        </div>
    );
}
